import { CustomField } from '@sales-center/common'
import { DraftLead } from '@user/store/draftLeads/typings'
import { IServiceLocation } from '@user/store/locations/typings'
import { ITargetPest } from '@user/store/targetPests'
import { createInitialValues, ILeadFormModel } from '../typings'
import { getDraftInitialValues } from '.'
import { NoteCode } from '@user/components/Notes/typings'
import { IEmployee } from '@user/store/employee'

export function getInitialValues(
  customFields: CustomField[],
  draft: DraftLead | undefined,
  allTargetPests: ITargetPest[],
  serviceLocation?: IServiceLocation,
  phone?: string | null,
  noteCodes?: NoteCode[],
  employees?: IEmployee[],
  addNewlocation?: boolean,
): ILeadFormModel {
  if (draft) {
    return getDraftInitialValues(
      customFields,
      draft,
      allTargetPests,
      serviceLocation,
      noteCodes,
      employees,
      addNewlocation,
    )
  } else {
    return createInitialValues(customFields, [], phone, addNewlocation)
  }
}
